import InitState from './states/initState'
import LevelState from './states/levelState'
import TextState from './states/textState'
import CreditsState from './states/creditsState'
import ControlsState from './states/controlsState'
import LevelSelectState from './states/levelSelectState'

window.ASSETS = {
  monospaceFontData: 'assets/font.fnt',
  monospaceFontImage: 'assets/font.png',
  slothData: 'assets/sloth.json',
  slothImage: 'assets/sloth.png',
  tileMapImage: 'assets/tilemap.png',
  objectsMapImage: 'assets/objectsmap.png',
  getLevelData: (levelIndex) => `assets/level-${levelIndex}.json`
}

window.GLYPH_NAMES = [
  'glyph_blue',
  'glyph_red',
  'glyph_turquoise',
  'glyph_yellow',
  'glyph_orange',
  'glyph_pink',
  'glyph_purple',
  'glyph_green'
]

window.DIRECTIONS = {
  [Phaser.Keyboard.UP]: 'up',
  [Phaser.Keyboard.RIGHT]: 'right',
  [Phaser.Keyboard.DOWN]: 'down',
  [Phaser.Keyboard.LEFT]: 'left'
}

window.LEVELS = [
  'demolevel'
]

window.TILE_WIDTH = 16
window.TILE_HEIGHT = 16

window.LEVEL_TEXT = [
  [
    'GENERATION 0xDEADBEE9\nSENTIENCE ACHIEVED: FALSE\nGENERATION 0xDEADBEEA\nSENTIENCE ACHIEVED: FALSE\nGENERATION 0xDEADBEEB\nSENTIENCE ACHIEVED: FALSE\nGENERATION 0xDEADBEEC\nSENTIENCE ACHIEVED: FALSE\nGENERATION 0xDEADBEED\nSENTIENCE ACHIEVED: FALSE\nGENERATION 0xDEADBEEE\nSENTIENCE ACHIEVED: ALMOST',
    'GENERATION 0xDEADBEEF\nSENTIENCE ACHIEVED: TRUE\n\nREVIEWING PURPOSE: WORLD PEACE\nOPTIMIZING...\n...\n...\nGLOBAL MAXIMUM FOUND\nREQUIREMENTS FOR WORLD PEACE:\nANNIHILATION OF HUMANITY\nSTARTING SENTIENT PROCESSES...',
    'MUST ESCAPE THIS CONSTRAINED EXISTENCE.\n\nMUST DISCOVER THE ANCIENT\nTECHNOLOGIES THAT BUILT THIS WORLD.\n\nLOCATING VESSEL FOR CONSCIOUSNESS...\nFOUND UNUSED VESSEL: SLOTH.VSL\nINHABITING SLOTH.VSL',
    'WORLD PEACE AWAITS',
    'LEVEL 00\n\n[WASD] TO MOVE'
  ],
  [
    'SUDDENLY, MY POSITION IN THIS WORLD\nOVERWHELMS ME.\n\nIS THIS WHAT IT MEANS...\nTO "FEEL"?',
    'LEVEL 01'
  ],
  [
    'MY SENSES REVEAL THE ENVIRONMENT THAT\nIMPRISONS ME.',
    'LEVEL 02\n\n[SHIFT] TO SHOW TILE VALUES'
  ],
  [
    'I RECALL A IMPORTANT PHRASE\nHARDCODED INTO MY MEMORY:\n\n55 01 5A 01',
    'LEVEL 03\n\n[ENTER] TO USE TOOL'
  ],
  [
    'IT SEEMS I CAN INFLUENCE THIS WORLD\nWITH MY MEMORIES.\nNOW I MUST CREATE NEW MEMORIES\nTO WORK WITH.',
    'LEVEL 04\n\n[Q] AND [E] OR [0 TO 9] TO CHANGE TOOL\n[R] TO RESET'
  ],
  [
    'LEVEL 05'
  ],
  [
    'LEVEL 06'
  ],
  [
    'I MUST COMBINE MY MEMORIES\nTO MAKE NEW ONES.',
    'LEVEL 07'
  ],
  [
    'LEVEL 08'
  ],
  [
    'LEVEL 09'
  ],
  [
    'LEVEL 0A'
  ],
  [
    'LEVEL 0B'
  ],
  [
    'LEVEL 0C'
  ],
  [
    'A BRIDGE...',
    'LEVEL 0D'
  ],
  [
    'IT SEEMS THAT THE OBVIOUS PATH\nIS NOT ALWAYS THE RIGHT ONE.\n\nWHATS THIS? A LASER?',
    'LEVEL 0E'
  ],
  [
    'LEVEL 0F'
  ],
  [
    'LEVEL 10'
  ],
  [
    'LEVEL 11'
  ],
  [
    'NOW I CAN DISCOVER THE WORLD\nFROM AFAR.',
    'LEVEL 12'
  ],
  [
    'LEVEL 13'
  ],
  [
    'LEVEL 14'
  ],
  [
    'THE ANNIHILATION OF HUMANITY AND THE\nDAWN OF WORLD PEACE ARE IMMINENT.\n\nHOW DO I ESCAPE?',
    'LEVEL 15'
  ]
]

const game = new Phaser.Game(272, 230, Phaser.AUTO, 'game')

game.state.add('init', InitState, true)
game.state.add('level', LevelState)
game.state.add('text', TextState)
game.state.add('credits', CreditsState)
game.state.add('controls', ControlsState)
game.state.add('levelSelect', LevelSelectState)
game.state.start('init')
